export default {
  rankOrder: {
    ariaAddOption: '{label} をランクリストに追加',
    ariaMoveUp: '{label} を上に移動',
    ariaMoveDown: '{label} を下に移動',
    ariaRemoveOption: '{label} をランクリストから削除',
  },
  coe: {
    ariaDisclaimer: '免責事項',
    ariaQuestion: '質問',
    ariaConversationHistory: '会話履歴',
    ariaYourResponse: 'あなたの回答 {number}',
    ariaFollowUpQuestion: 'フォローアップ質問 {number}',
    ariaResponseInput: '回答入力欄',
    ariaRespondingTo: '回答中',
    ariaSendResponse: '回答を送信',
    ariaThinking: '考え中'
  },
  deviceView: {
    toolbar: 'プレビューデバイス',
    mobile: 'モバイル',
    tablet: 'タブレット',
    desktop: 'デスクトップ'
  },
  header: {
    customLogoAlt: 'ロゴ',
    defaultLogoAlt: 'QuestDIYロゴ'
  }
}
